import React, { lazy, useState, useEffect, Suspense } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useContextHook } from 'use-context-hook';
import pages from '../nav.json';
import Layout from '../components/Layout';
import Loaders from '../components/atoms/Loaders';
import Toast from '../components/molecules/Toast';
import { AuthContext } from '../Context/authContext';

const importView = file =>
  lazy(() =>
    import(`./${file}`).catch(() => {
      Toast({
        type: 'error',
        message: `Error in importing ${file}`,
      });
    }),
  );

export default function Index() {
  const { loading_user } = useContextHook(AuthContext, ['loading_user']);
  const history = useNavigate();
  const location = useLocation();

  const { view } = useParams();
  const metaViewData = pages;
  const [selectedView, setSelectedView] = useState([]);

  async function loadView(filtered) {
    // Add validation to ensure filtered array contains valid objects
    if (!filtered || filtered.length === 0 || !filtered[0]) {
      Toast({
        type: 'error',
        message: 'Invalid route or page not found',
      });
      // Redirect to dashboard as fallback
      history('/dashboard', { replace: true });
      return;
    }

    const promise = filtered.map(async _view => {
      if (!_view || !_view.file) {
        Toast({
          type: 'error',
          message: 'Invalid view configuration',
        });
        return null;
      }

      const View = await importView(_view.file);

      // eslint-disable-next-line no-use-before-define
      return <View key={_view.id || _view.file} selectView={selectView} />;
    });
    const validPromises = promise.filter(p => p !== null);
    if (validPromises.length > 0) {
      Promise.all(validPromises).then(setSelectedView);
    }
  }

  async function selectView(file) {
    if (!file) {
      // Toast({
      //   type: 'error',
      //   message: 'No file specified',
      // });
      history('/dashboard', { replace: true });
      return;
    }

    const filtered = metaViewData.filter(elem => elem.file === file);

    if (filtered.length === 0) {
      // Toast({
      //   type: 'error',
      //   message: `Page "${file}" not found`,
      // });
      history('/dashboard', { replace: true });
      return;
    }

    loadView([filtered[0]]);
  }

  useEffect(() => {
    let fileToLoad = view;

    // Validate that the view exists in navigation data
    const viewExists = metaViewData.some(elem => elem.file === fileToLoad);

    if (!viewExists) {
      // Toast({
      //   type: 'error',
      //   message: `Page "${fileToLoad}" not found. Redirecting to dashboard.`,
      // });
      history('/dashboard', { replace: true });
      return;
    }

    const targetPath = `/${fileToLoad}`;
    if (location.pathname !== targetPath) {
      history({ pathname: targetPath, search: location.search }, { replace: true });
    }
    selectView(fileToLoad);
  }, [view, loading_user]);

  return (
    <Layout
      merged={view === 'dashboard'}
      title={view}
      showTemplate={metaViewData?.filter(elem => elem.file === view)[0]?.navigations}
      topBar>
      <Suspense fallback={<Loaders viewLoader />}>{selectedView}</Suspense>
    </Layout>
  );
}
